$(document).ready(function() {
  $(document).on('click', '.js-withdrawal', function(e){
    $.ajax({
      url: $(this).closest('form').data('subaction'),
      dataType: 'json',
      type: 'PUT',
      data: { 'withdrawal_type' : $(this).val() }
    });
  });
});
